import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';

const ProfileEdit = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col></Col>
      </Row>
    </Container>
  </Fade>
);
export default ProfileEdit;
